import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger } from "@/components/ui/select";

export enum SortPredictionMarketEnum {
  Recommended = "おすすめ",
  RapidlyRising = "急上昇中",
  Popular = "人気順",
  NewArrivals = "新着順",
  ClosingSoon = "締切間近",
  FiftyFifty = "50:50",
}

type SelectSortPredictionMarketProps = {
  selectedSortPredictionMarketType: SortPredictionMarketEnum;
  setSelectedSortPredictionMarketType: (selectedSortPredictionMarketType: SortPredictionMarketEnum) => void;
  className?: string;
};

export const SelectSortPredictionMarket = ({
  selectedSortPredictionMarketType,
  setSelectedSortPredictionMarketType,
  className,
}: SelectSortPredictionMarketProps) => {
  return (
    <Select
      value={selectedSortPredictionMarketType}
      onValueChange={(value: SortPredictionMarketEnum) => setSelectedSortPredictionMarketType(value)}
    >
      <SelectTrigger
        className={`max-w-fit border-secondary rounded-lg text-[#0098EA] font-semibold ring-0 focus:ring-0 text-center ${className ?? ""}`.trim()}
        iconClassName="opacity-100 text-secondary w-5 h-5"
      >
        <p className="w-full text-center px-1 text-xs font-bold">{selectedSortPredictionMarketType}</p>
      </SelectTrigger>

      <SelectContent className="rounded-lg">
        <SelectGroup>
          {Object.values(SortPredictionMarketEnum).map((value) => (
            <SelectItem key={value} value={value}>
              {value}{" "}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};
